function ensureValue(value, message) {
  if (value === undefined || value === null || value === '') {
    throw new Error(message);
  }
  return value;
}

function buildBztQrcodeParams(orderNo) {
  return {
    orderNo: ensureValue(orderNo, '订单号为空'),
  };
}

function buildBztQueryParams(orderNo, qrcodeid) {
  return {
    orderNo: ensureValue(orderNo, '订单号为空'),
    qrcodeid: ensureValue(qrcodeid, '标证通二维码编号为空'),
  };
}

function extractBztQrContent(responseData) {
  const qrInfo = responseData && responseData.qrInfo;
  return {
    qrcodeid: ensureValue(qrInfo && qrInfo.qrcodeid, '标证通二维码编号为空'),
    content: ensureValue(qrInfo && qrInfo.content, '标证通二维码内容为空'),
  };
}

module.exports = {
  buildBztQrcodeParams,
  buildBztQueryParams,
  extractBztQrContent,
};
